/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { ContentZoneContext } from "cms/components/context";
import { RoutewareCalendarComponent } from "cms/components/components/routeware-calendar/display/routeware-calendar";

const RoutewareCalendarComponentDisplay = () => {
    
    const contentZoneContext = useContext(ContentZoneContext);
    const component = contentZoneContext?.component;

    return (
        <>
            <h2>Routeware Calendar</h2>
            <RoutewareCalendarComponent
                component={component}
            />
        </>
    );
};

RoutewareCalendarComponentDisplay.displayName = "RoutewareCalendarComponentDisplay";
export { RoutewareCalendarComponentDisplay };

